'use strict';

/** @type {import('.')} */
module.exports = Object;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-object-atoms/index.js
 ** module id = 311
 ** module chunks = 0
 **/